import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const API_URL = import.meta.env.VITE_API_URL;

const OccurrenceService = {
    findByPlate: async (plate) => axios.post(API_KEEPER + "/fact/occurrence/findByPlateWeb", {plate, showFiled: false}).then(({data}) => data).catch((err) => { throw err }),

    findByCpf: async (cpf) => axios.post(API_KEEPER + "/fact/occurrence/findByCpfIndividualWeb", {cpf, showFiled: false}).then(({data}) => data).catch((err) => { throw err }),

    openSentryViewOccurrence: async (id) => axios.get(API_URL + `/occurrence/open-sentryview/${id}`).then(({data}) => data).catch((err) => { throw err }),

    openSentryViewOccurrencesList: async (data) => axios.post(API_URL + "/occurrence/openAssociatedOccurrencesSentryView", data).catch((err) => { throw err }),
};

export default OccurrenceService;